// extracted by mini-css-extract-plugin
module.exports = {"textLoading":"style_textLoading__EUew6","bounceballLoading":"style_bounceballLoading__3koEb","bounce":"style_bounce__1L-p8"};